import { sortBasedOnReferenceOrder } from "core/utils/sortBasedOnReferenceOrder";
import type {
  QuickLinkCreateUpdateDto,
  QuickLinkWidgetFormValues,
  QuickLinkWidgetSettingsCreateUpdateDto,
} from "./QuickLinkDefs";

export function mapQuickLinkFormDataToCreateUpdateDto(
  formValues: QuickLinkWidgetFormValues,
  brcy: string,
  treeIdToNodeId: (id: string) => string | undefined
): QuickLinkWidgetSettingsCreateUpdateDto {
  const sortedIds = sortBasedOnReferenceOrder(
    formValues.selectedQuickLinks.map((ql) => ql.id),
    formValues.quickLinkOrder
  );
  const quickLinkMap = new Map(
    formValues.selectedQuickLinks.map((ql) => [ql.id, ql])
  );
  const quickLinks: QuickLinkCreateUpdateDto[] = [];
  let order = 0;
  sortedIds.forEach((id) => {
    const ql = quickLinkMap.get(id);
    if (!ql) {
      return;
    }

    if (ql.type === "DocNode") {
      const nodeId = treeIdToNodeId(id);
      if (!nodeId) {
        return;
      }
      quickLinks.push({
        type: "DocNode",
        order: order++,
        docNodeId: nodeId,
      });
    } else if (ql.type === "CustomLink" && ql.customLink) {
      quickLinks.push({
        type: "CustomLink",
        order: order++,
        customLink: {
          target: "_blank",
          translations: ql.customLink.translations.map((tr) => ({
            locale: tr.locale,
            name: tr.name,
            url: tr.url,
          })),
        },
      });
    }
  });

  return {
    brcyCode: brcy,
    enabled: formValues.isEnabled,
    quickLinks,
  };
}
